import script from "./mobileProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileProduct.vue?vue&type=script&setup=true&lang=js"

import "./mobileProduct.css?vue&type=style&index=0&id=1f261988&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f261988"]])

export default __exports__